import React, { useEffect } from "react";
import { Box } from "@mui/material";
import styles from "./style.module.css";
import Header from "./header";
import Content from "./content";
import { useTheme } from "../../context/themeContext";
import UseLocalStorageState from "../../hooks/useLocalStorageState";
import useProtectedAuth from "../../hooks/useProtectedAuth";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setPublicUser } from "../../store/slices/profile/publicUserSlice";
import { setIsPageLoading } from "../../store/slices/loadingSlice";
import axios from "axios";
import { node_server } from "../../constants";

function PublicProfileView() {
  useProtectedAuth();
  const { theme } = useTheme();
  const [value, setValue] = UseLocalStorageState("profile-bar", 1);
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPublicUser = async () => {
      const { data, error } = await axios.get(
        `${node_server}/api/user/${params.id}`,
        {
          withCredentials: true,
        },
      );

      if (error) console.log(error);
      if (data) {
        dispatch(setPublicUser(data));
        dispatch(setIsPageLoading(false));
      }
    };

    if (params?.id) {
      dispatch(setIsPageLoading(true));
      fetchPublicUser();
    }
  }, [params]);

  const data = {
    value,
    setValue,
  };

  return (
    <Box className={styles.parent}>
      <Box
        className={styles.cardDetails}
        sx={{
          bgcolor: theme.palette.lightgrey.lightgrey600,
        }}
      >
        <Header data={data} />
        <Content value={value} />
      </Box>
    </Box>
  );
}

export default PublicProfileView;
